import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Select from 'react-select';
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom'
import { Table } from "antd";
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        code: Yup.string().required('Code is required'),
        short_name: Yup.string().required('Short Name is required'),
        applicabl_for: Yup.string().required('Applicable for is required'),
        charge_category: Yup.string().required('Charge Category is required'),
        IATA_code: Yup.string().required('IATA Code is required'),
        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type
            code: '',
            short_name: '',
            applicabl_for: '',
            charge_category: '',
            IATA_code: '',
            name: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });

    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Charge Name", dataIndex: "Name", key: "Name" },
        { title: "Charge Type", dataIndex: "Type", key: "Type" },
        { title: "Charge Group", dataIndex: "Group", key: "Group" },
        { title: "Action", dataIndex: "action", key: "action" },
      ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "John", 
        Type: "AE",
        Group: "ddsvd",
        action: (
          <div className="dropdown table-action">
            <Link to="#" className="action-icon" data-bs-toggle="dropdown">
              <i className="fa fa-ellipsis-v"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <div className="dropdown-item cursor-pointer" to="#" >
                <i className="fas fa-trash text-blue me-2"></i> Delete
              </div>
            </div>
          </div>
        )
      }];

    const ApplicableOption = []
    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Default Charge</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
            <form onSubmit={formik.handleSubmit}>
                <div className="row mb-3">
                                    <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Charge Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className="custom-selector"
                                        options={ApplicableOption}
                                        value={ApplicableOption.find(option => option.value === formik.values.applicableFor) || null}
                                        onChange={(selectedOption) => formik.setFieldValue("applicableFor", selectedOption.value)}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.charge_category && formik.errors.charge_category ? (
                                        <div className="error">{formik.errors.charge_category}</div>
                                    ) : null}
                                    {formik.touched.IATACode && formik.errors.IATACode ? (
                                        <div className="error">{formik.errors.IATACode}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                        <button className="btn btn-primary text-xs" type="submit">
                            Add Charge
                        </button>
                        </div>
                        </div>
                                    <div className="table-responsive custom-table">
                <Table className="table datanew dataTable no-footer" pagination={false}
                  dataSource={dataSource} columns={columns} />
              </div>
                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Submit
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster